export default "__VITE_ASSET__Dz6G38Lq__"